import React,{useEffect,useState} from 'react'
import {useParams} from 'react-router-dom'
import Details from '../components/Details'
import ExerciseVideos from '../components/ExerciseVideos'
import SimilarExercises from '../components/SimilarExercises'
import {Box} from '@mui/material'
import { exercisesOptions, fetchData, youTubeOptions } from '../utils/fetchData'

const ExerciseDetail = () => {
  const [exerciseDetail,setExerciseDetail]=useState({});
  const [exerciseVideos,setExerciseVideos] = useState([]);
  const [targetMuscleExercises,setTargetMuscleExercises]=useState([]);
  const [equipmentExercise,setEquipmentExercise]=useState([]);
  const {id}=useParams();

  useEffect(()=>{
    
     
       const fetchExerciseDetails= async() =>{
   
            const exerciseUrl='https://exercisedb.p.rapidapi.com';
            const youTubeUrl='https://youtube-search-and-download.p.rapidapi.com';
            const exerciseDetailData=await fetchData(`${exerciseUrl}/exercises/exercise/${id}`,exercisesOptions);
            const exerciseVideosData=await fetchData(`${youTubeUrl}/search?query=${exerciseDetailData.name}`,youTubeOptions);
            setExerciseDetail(exerciseDetailData);
            setExerciseVideos(exerciseVideosData.contents);

            const targetMuscleExercisesData=await fetchData(`${exerciseUrl}/exercises/target/${exerciseDetailData.target}`,exercisesOptions);
            const equipmentExerciseData=await fetchData(`${exerciseUrl}/exercises/equipment/${exerciseDetailData.equipment}`,exercisesOptions);
            setEquipmentExercise(equipmentExerciseData);
            setTargetMuscleExercises(targetMuscleExercisesData);
            
           
       }
       fetchExerciseDetails();
       
  },[id]);

  return (
    <Box>
       <Details exerciseDetail={exerciseDetail}/>
       <ExerciseVideos exerciseVideos={exerciseVideos} name={exerciseDetail.name} />
       <SimilarExercises targetMuscleExercise={targetMuscleExercises} equipmentExercise={equipmentExercise}/>
    </Box>
  )
}

export default ExerciseDetail